module.exports = __webpack_public_path__ + "img/cut_xl3.1dd5e682.jpg";